import { Component, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';
import { MessageNoteInfo, MessageNotesSearchCriteria as MessageNotesSearchCriteria } from '@models';
import { AppMessageService } from '@services/message.service';
import { UserService } from '@services/user.service';
import { Authorization } from 'app/shared/classes/authorization';
import { CommonShared } from 'app/shared/classes/common';
import { select } from 'd3';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';


export interface ChangeLogNotesParams {
  changeLogNotes: string;
  userGroupId: number;
  category: string;
}

@Component({
  standalone: false,
  selector: 'changelog-notes',
  templateUrl: './changelognotes.component.html',
  styleUrls: ['./changelognotes.component.scss']
})

export class ChangeLogNotesComponent implements OnInit, ChangeLogNotesParams {

  @Output() onChangeLogNotes = new EventEmitter<any>();

  common = new CommonShared();
  auth = new Authorization();

  modalDragOn: boolean = false;

  changeLogNotes: string = '';
  userGroupId: number = 0
  category: string = 'empty'

  username: string = '';
  messageNoteInfos: MessageNoteInfo[] = [];
  messageNotesLoaded: boolean = false;
  selectedNote: MessageNoteInfo;


  constructor(public bsModalRef: BsModalRef, private toastr: ToastrService, private modalService: BsModalService,
              public _userService: UserService, public _appMessageService: AppMessageService) {
  }


  ngOnInit() {
    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {
        this.username = results['value'];
        if (this.username != null && this.username !== '') {
          this.startUp();
        }
      },
      err => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }


  startUp() {
    if (this.userGroupId > 0 && this.category != undefined && this.category != '') {
      this.getMessageNotes();
    }
    else {
      this.messageNotesLoaded = true;
    }
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  saveChangeLogNotes() {
    this.onChangeLogNotes.emit(this.changeLogNotes);
    this.bsModalRef.hide();
  }

  cancelChangeLogNotes() {
    this.changeLogNotes = '';
    this.bsModalRef.hide();
  }


  getMessageNotes(): void {
    this.messageNotesLoaded = false;

    var searchCriteria: MessageNotesSearchCriteria = {
      userGroupId: this.userGroupId,
      category: this.category
    };
    
    this._appMessageService.getMessageNotes(searchCriteria).subscribe(
      results => {
        if (results != null) {
          this.messageNoteInfos = results;
          
          if (this.messageNoteInfos != undefined && this.messageNoteInfos.length > 0) {
            var note: MessageNoteInfo = {
              id: 0,
              userGroupId: this.userGroupId,
              category: this.category,
              title: '',
              note: '-other-'
            }
            this.messageNoteInfos.push(note);
          }
        }
        this.messageNotesLoaded = true;
        return;
      },
      err => {
        this.messageNotesLoaded = true;
        this.toastr.error('Error occurred while retrieving change log message options.');
      });
  }


  messageNoteSelected() {
    if (this.selectedNote == undefined) {
      this.category = '';
      this.changeLogNotes = '';
      return;
    }

    if (this.selectedNote.note == '-other-') {
      this.category = '-other-';
    }
    else {
      this.category = this.selectedNote.category;
      this.changeLogNotes = this.selectedNote.note;
    }
  }


}
